import { dateStringToDashDateString } from 'routes/HumanResourcesModule/business/helpers';
import {
    DashDateString,
    DateString,
} from 'routes/HumanResourcesModule/business/types';

export const transformDateKeys = (
    valuesByDates: Record<DateString, number>,
): Record<DashDateString, number> =>
    Object.fromEntries(
        Object.entries(valuesByDates).map(([k, v]: [DateString, number]) => [
            dateStringToDashDateString(k),
            v,
        ]),
    );
